// import resume from '../assets/pdf/resume.pdf'
import resume5 from '../assets/pdf/Technical_PM_MBridi.pdf'

export const headerData = {
    name: 'Melissa Bridi',
    title: "Senior Associate, Technical Services @ Paradigm Health AI",
    description:" I\'m a research scientist now working in health tech. Enjoys: travel, continuous learning, music and cycling",
    image: 'https://avatars.githubusercontent.com/u/91221861?s=400&u=39947d831d35f97ed31f2f24f72b5d5be932387f&v=4',
    resumePdf: resume5
}
